var map = {
	"./error.svg": 497,
	"./info.svg": 498,
	"./success.svg": 499,
	"./warning.svg": 500
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 694;


//////////////////
// WEBPACK FOOTER
// ./src/components/message/src/assets ^\.\/.*\.svg$
// module id = 694
// module chunks = 0